import script from "./AcoesCampos.vue?vue&type=script&setup=true&lang=js"
export * from "./AcoesCampos.vue?vue&type=script&setup=true&lang=js"

import "./AcoesCampos.vue?vue&type=style&index=0&id=46173908&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46173908"]])

export default __exports__